import axiosInstance from "@/api/axiosInstance";
import { FetchCompanyReservationsResponse } from "./types";

export const fetchCompanyReservations = async (
  eventUuid: string,
): Promise<FetchCompanyReservationsResponse> => {
  const url = `/api/private/events/${eventUuid}/company-reservations`;
  const response =
    await axiosInstance.get<FetchCompanyReservationsResponse>(url);

  return response.data;
};
